// extracted by mini-css-extract-plugin
export default {"melodyVideo":"IJ-z","isFullWidth":"JJ-z","landingPageVideo":"KJ-z","play":"LJ-z","iframeVideo":"MJ-z","playHidden":"NJ-z","fullwidth":"OJ-z"};